module.exports = __webpack_public_path__ + "img/card-provider-contact.7c80c6de.svg";